(function() {
  function initTimerBlock(timerElement) {
    var daysEl = timerElement.querySelector('.bk-media-timer-block__timer-days');
    var hoursEl = timerElement.querySelector('.bk-media-timer-block__timer-hours');
    var minutesEl = timerElement.querySelector('.bk-media-timer-block__timer-minutes');
    var secondsEl = timerElement.querySelector('.bk-media-timer-block__timer-seconds');
    var timerBlock = timerElement.closest('.bk-media-timer-block');
    var progressBarFill = timerBlock ? timerBlock.querySelector('.bk-media-timer-block__progress-bar-fill') : null;

    if (!daysEl || !hoursEl || !minutesEl || !secondsEl) {
      return;
    }

    var metaobjectDate = (timerElement.getAttribute('data-metaobject-date') || '').trim();
    var metaobjectStartDate = (timerElement.getAttribute('data-metaobject-start-date') || '').trim();
    var restartAtSevenDays = timerElement.getAttribute('data-restart-seven-days') === 'true';
    var cycleMs = 7 * 24 * 60 * 60 * 1000;
    var endTime;

    function parseDateToTimestamp(dateString) {
      if (!dateString) return null;
      var trimmed = dateString.trim();
      if (!trimmed) return null;

      var numeric = parseInt(trimmed, 10);
      if (!isNaN(numeric) && numeric > 0) {
        return numeric < 10000000000 ? numeric * 1000 : numeric;
      }

      var parsed = new Date(trimmed);
      if (!isNaN(parsed.getTime())) return parsed.getTime();

      return null;
    }

    if (metaobjectDate) {
      endTime = parseDateToTimestamp(metaobjectDate);
      if (endTime == null) return;
    } else {
      return;
    }

    function pad(n) {
      return n < 10 ? '0' + n : '' + n;
    }

    function getCycleRemainingMs(now) {
      var remainingMs = endTime - now;
      if (!restartAtSevenDays || remainingMs >= 1000) {
        return Math.max(0, remainingMs);
      }

      var elapsedMs = Math.max(0, now - endTime);
      var remainder = elapsedMs % cycleMs;
      return remainder === 0 ? cycleMs : cycleMs - remainder;
    }

    function updateTimer() {
      var now = Date.now();
      var remainingMs = getCycleRemainingMs(now);
      var remaining = Math.floor(remainingMs / 1000);
      var isRestartCycle = restartAtSevenDays && (endTime - now) < 1000;

      var days = Math.floor(remaining / 86400);
      remaining = remaining % 86400;
      var hours = Math.floor(remaining / 3600);
      remaining = remaining % 3600;
      var mins = Math.floor(remaining / 60);
      var secs = remaining % 60;

      daysEl.textContent = pad(days);
      hoursEl.textContent = pad(hours);
      minutesEl.textContent = pad(mins);
      secondsEl.textContent = pad(secs);

      if (progressBarFill && !(timerBlock && timerBlock.getAttribute('data-inventory-progress') === 'true')) {
        if (isRestartCycle) {
          progressBarFill.style.width = Math.min(100, Math.max(0, (remainingMs / cycleMs) * 100)) + '%';
        } else if (metaobjectStartDate) {
          var parsedStartDate = parseDateToTimestamp(metaobjectStartDate);
          if (parsedStartDate !== null && endTime) {
            var totalDurationSeconds = Math.floor((endTime - parsedStartDate) / 1000);

            if (totalDurationSeconds > 0) {
              var elapsedSeconds = Math.max(0, Math.floor((now - parsedStartDate) / 1000));
              var remainingSeconds = Math.max(0, totalDurationSeconds - elapsedSeconds);
              var progress = 0;

              if (elapsedSeconds <= totalDurationSeconds) {
                progress = (remainingSeconds / totalDurationSeconds) * 100;
              } else {
                progress = 0;
              }

              progressBarFill.style.width = Math.min(100, Math.max(0, progress)) + '%';
            }
          }
        } else {
          progressBarFill.style.width = '35%';
        }
      }
    }

    updateTimer();
    var interval = setInterval(updateTimer, 1000);
    timerElement.dataset.intervalId = interval;
  }

  function initTimerBlocks() {
    document.querySelectorAll('.bk-media-timer-block__timer').forEach(function(timer) {
      var existingIntervalId = timer.dataset.intervalId;
      if (existingIntervalId) {
        clearInterval(parseInt(existingIntervalId, 10));
        delete timer.dataset.intervalId;
      }

      timer.dataset.initialized = 'true';
      try {
        initTimerBlock(timer);
      } catch (error) {
        timer.dataset.initialized = 'false';
      }
    });
  }

  function initTimerCopyButtons() {
    document.querySelectorAll('.bk-media-timer-block__code-badge').forEach(function(button) {
      if (button.dataset.copyInitialized) return;
      button.dataset.copyInitialized = 'true';

      button.addEventListener('click', function() {
        var code = this.dataset.code;
        if (!code) return;

        var textEl = this.querySelector('.bk-media-timer-block__code-text');
        var originalText = textEl ? textEl.textContent : '';
        var originalBadgeText = this.textContent;
        var self = this;

        function showCopied() {
          var copiedLabel = self.getAttribute('data-copied-label') || 'Copied!';
          var codeCopiedLabel = self.getAttribute('data-code-copied-label') || 'CODE: Copied!';
          if (textEl) {
            textEl.textContent = copiedLabel;
          } else {
            self.textContent = codeCopiedLabel;
          }
          setTimeout(function() {
            if (textEl) {
              textEl.textContent = originalText;
            } else {
              self.textContent = originalBadgeText;
            }
          }, 2000);
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(showCopied).catch(function() {});
        } else {
          var textArea = document.createElement('textarea');
          textArea.value = code;
          textArea.style.position = 'fixed';
          textArea.style.opacity = '0';
          document.body.appendChild(textArea);
          textArea.select();
          try {
            document.execCommand('copy');
            showCopied();
          } catch (err) {
          } finally {
            document.body.removeChild(textArea);
          }
        }
      });
    });
  }

  function initializeTimerBlocks() {
    initTimerBlocks();
    initTimerCopyButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeTimerBlocks);
  } else {
    setTimeout(initializeTimerBlocks, 100);
  }

  document.addEventListener('shopify:section:load', function() {
    setTimeout(initializeTimerBlocks, 100);
  });

  document.addEventListener('product:rerender', function() {
    setTimeout(initializeTimerBlocks, 100);
  });
})();

(function() {
  function fieldValue(form, name) {
    var fields = form.querySelectorAll('[name="' + name + '"]');
    var active = Array.prototype.filter.call(fields, function(field) {
      return !field.disabled && (field.type !== 'radio' || field.checked);
    });
    var field = active[0] || fields[0];
    return field ? String(field.value || '').trim() : '';
  }

  function setHiddenValue(form, name, value) {
    var field = form.querySelector('[name="' + name + '"]:not([disabled])') || form.querySelector('[name="' + name + '"]');
    if (field) field.value = value;
  }

  function wrapMitteilung(text) {
    var clean = String(text || '').replace(/^\s*\[\[/, '').replace(/\]\]\s*$/, '').trim();
    return '[[' + clean + ']]';
  }

  function addLine(lines, label, value) {
    if (value) lines.push(label + ': ' + value);
  }

  function setPanel(form, topic) {
    var panels = form.querySelectorAll('[data-contact-panel]');
    panels.forEach(function(panel) {
      var active = panel.getAttribute('data-contact-panel') === topic;
      panel.hidden = !active;
      panel.querySelectorAll('input, select, textarea').forEach(function(el) {
        el.disabled = !active;
      });
    });
  }

  function syncMappingFields(form, topic) {
    var firstName = fieldValue(form, 'contact[Vorname]');
    var lastName = fieldValue(form, 'contact[Nachname]');
    var email = fieldValue(form, 'contact[email]');
    var thema = fieldValue(form, 'contact[Thema]') || (topic === 'complaint' ? 'Reklamation' : 'Allgemeine Frage');
    var url = fieldValue(form, 'contact[URL]') || window.location.host;
    var message = fieldValue(form, 'contact[Mitteilung]');

    if (topic === 'complaint' && !message) {
      message = [
        fieldValue(form, 'contact[Grund lt. Verbraucher]') && ('Grund lt. Verbraucher: ' + fieldValue(form, 'contact[Grund lt. Verbraucher]')),
        fieldValue(form, 'contact[Produkt]') && ('Produkt: ' + fieldValue(form, 'contact[Produkt]')),
        fieldValue(form, 'contact[MHD]') && ('MHD: ' + fieldValue(form, 'contact[MHD]')),
        fieldValue(form, 'contact[Chiffre]') && ('Chiffre: ' + fieldValue(form, 'contact[Chiffre]')),
        fieldValue(form, 'contact[Wo wurde das Prod. gekauft?]') && ('Wo wurde das Prod. gekauft?: ' + fieldValue(form, 'contact[Wo wurde das Prod. gekauft?]'))
      ].filter(Boolean).join('\n');
    }

    var mitteilung = wrapMitteilung(message);
    var mitteilungField = form.querySelector('[name="contact[Mitteilung]"]:not([disabled])');
    if (mitteilungField) mitteilungField.value = mitteilung;

    var lines = [];
    addLine(lines, 'Anrede', fieldValue(form, 'contact[Anrede]'));
    addLine(lines, 'Vorname', firstName);
    addLine(lines, 'Nachname', lastName);
    addLine(lines, 'E-Mail', email);
    addLine(lines, 'Mitteilung', mitteilung);
    lines.push('');
    addLine(lines, 'Thema', thema);
    addLine(lines, 'URL', url);
    addLine(lines, 'Straße', fieldValue(form, 'contact[Straße]'));
    addLine(lines, 'Hausnummer', fieldValue(form, 'contact[Hausnummer]'));
    addLine(lines, 'PLZ', fieldValue(form, 'contact[PLZ]'));
    addLine(lines, 'Ort', fieldValue(form, 'contact[Ort]'));
    addLine(lines, 'Land', fieldValue(form, 'contact[Land]'));

    setHiddenValue(form, 'contact[name]', [firstName, lastName].filter(Boolean).join(' '));
    setHiddenValue(form, 'contact[body]', lines.join('\n'));
    setHiddenValue(form, 'contact[URL]', url);
  }

  function initContactForm(form) {
    if (!form || form.getAttribute('data-contact-initialized') === 'true') return;
    form.setAttribute('data-contact-initialized', 'true');

    var topicInputs = form.querySelectorAll('[data-contact-topic]');
    var selected = form.querySelector('[data-contact-topic]:checked');
    setPanel(form, selected ? selected.getAttribute('data-contact-topic') : 'general');

    topicInputs.forEach(function(input) {
      input.addEventListener('change', function() {
        setPanel(form, input.getAttribute('data-contact-topic'));
      });
    });

    form.addEventListener('submit', function() {
      var current = form.querySelector('[data-contact-topic]:checked');
      syncMappingFields(form, current ? current.getAttribute('data-contact-topic') : 'general');
    });
  }

  function initContactForms() {
    document.querySelectorAll('.bk-media-contact-form').forEach(initContactForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initContactForms);
  } else {
    initContactForms();
  }

  document.addEventListener('shopify:section:load', function() {
    setTimeout(initContactForms, 100);
  });
})();
